import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import "./index.css";
import App from "./App.jsx";
import { queryClient } from "./lib/queryClient.js";
import { ThemeProvider } from "./context/ThemeContext.jsx";
import { AuthProvider } from "./context/AuthContext.jsx";
import FeedbackProvider from "./components/ui/FeedbackProvider.jsx";

/*
 * Provider order matters:
 *
 *   QueryClientProvider   AuthProvider clears the cache on sign-out
 *   ThemeProvider         no dependencies
 *   FeedbackProvider      outside the router, so a toast survives navigation
 *   BrowserRouter         ┐ AuthProvider does not navigate, but the guard it
 *   AuthProvider          ┘ feeds (RequireAuth) does, so it sits inside
 *
 * StrictMode is ON, unlike the Next.js app which set reactStrictMode: false "to
 * prevent double rendering in development". That hid effect-cleanup bugs rather
 * than fixing them — and it earned its keep immediately: the double invocation
 * exposed a guard/cleanup deadlock in AuthProvider's boot-time token check that
 * would have shipped as a permanent "Checking your session…" hang.
 */
createRoot(document.getElementById("root")).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <FeedbackProvider>
                    <BrowserRouter>
                        <AuthProvider>
                            <App />
                        </AuthProvider>
                    </BrowserRouter>
                </FeedbackProvider>
            </ThemeProvider>
        </QueryClientProvider>
    </StrictMode>,
);
